import { getWhiteLabelKey, isJimssoftWhiteLabel } from "./white-label";

export const AUTH_LINKEDIN_URL = "https://www.linkedin.com/company/exacc-au";

const JIMSSOFT_WEBSITE_URL = "https://jimstax.com.au/";
const IPASOFT_WEBSITE_URL = "https://ipasoft.au/";
const DEFAULT_WEBSITE_URL = "https://exacc.au";

export function getAuthWebsiteUrl() {
  const key = getWhiteLabelKey();
  if (isJimssoftWhiteLabel()) {
    return JIMSSOFT_WEBSITE_URL;
  }
  if (key === "ipasoft") {
    return IPASOFT_WEBSITE_URL;
  }
  return DEFAULT_WEBSITE_URL;
}

export function getAuthShowLinkedIn() {
  return !isJimssoftWhiteLabel();
}
